import { useMemo, useState } from "react";
import { axiosGetWithHeader, ShowAlertError } from "../Common/axios";
import { AppHeader } from "./AppHeader";
import { useLocation } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import { AppFooter } from "./AppFooter";

import { AstrologerInfoFooter } from "../Common/AstrologerInfoFooter";
import { ClientDetailsPageMenu } from "./ClientDetailsPageMenu";
import { ClientDetailsTab } from "./Basic/ClientDetailsTab";

export function ClientDetailsPage()  {
  const {state} = useLocation();
  const runningId = state?state.runningId:null;
  const [userData, setUserData] = useState(null);
  const [clientData, setClientData] = useState(null);
  const [menuArray, setMenuArray] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Client Details Page');
  const [errorAlert, setErrorAlert] = useState(null);
  const handleMenu = (menuArray)=>setMenuArray(menuArray);

  useMemo(() => {
    axiosGetWithHeader("/userrequest/"+runningId,
      (response)=>{
        setUserData(response.data);
        getClientData(response.data.id);
        setSpinner(null);
      },
      (error)=>{
        setUserData(null);
        setSpinner(null);
        console.log(error);
        setErrorAlert(error.message);
      }
    );
  }, [runningId]);

  function getClientData(clientId) {
    axiosGetWithHeader("/chart/userdata/"+clientId,
      (response)=>{
        setClientData(response.data);
      },
      (error)=>{
        console.log(error);
        setClientData(null);
        setErrorAlert(error.message);
      }
    );
  }

  return (
    <>
        <div class="m-0 p-0 row sticky-top bg-white noprint">
            <div class="m-0 p-0 col-12">
                <AppHeader/>
                <ClientDetailsPageMenu userData={userData} handleMenu={handleMenu} />
            </div>    
        </div> 
        {spinner===null?<></>:<div class="text-center text-primary h5 pt-5">{spinner} <Spinner animation="border" size="sm" /></div>}
        { clientData===null || clientData===undefined || clientData.length===0 || userData===null || userData===undefined || userData.length===0?<div class="menupageheight"></div>:
        <>
        <div class="m-0 p-0 row align-items-top">
            <div class="m-0 p-0 col-12">
              <div class="menupageheight">
                <ClientDetailsTab menuArray={menuArray} userData={userData} clientData={clientData}/>
              </div>  
            </div>
        </div>
        </>}
        <div class="m-0 p-0 row noprint">
            <div class="m-0 p-0 col-12">
                <AppFooter/>
            </div>    
        </div>
        <div class="m-0 p-0 row d-none d-print-block printfooter">
          <div class="m-0 p-0 col-12">
            <AstrologerInfoFooter userData={userData}  />
          </div>    
        </div> 
        <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
    </>
  );
}
